import styled from "styled-components";

import { BarChart as BarChartUI, barChartClassNames } from "@evergis/charts";

export const BarChart = styled(BarChartUI)`
  .${barChartClassNames.barChartXAxis} {
    .domain,
    line {
      display: none;
    }

    .tick {
      text {
        text-anchor: start;
        font-size: 12px;
        color: ${({ theme: { palette } }) => palette.textSecondary};
      }

      :last-of-type {
        text {
          text-anchor: end;
        }
      }
    }
  }

  .marker {
    font-size: 12px;
  }
`;

export const TooltipContainer = styled.div`
  position: relative;
  font-size: 0.75rem;
  color: #fff;
  margin-bottom: 0.5rem;
  padding: 0.375rem;
  background-color: rgba(48, 69, 79, 1);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.xSmall};
  box-shadow: 0 0.1875rem 0.5rem rgba(48, 69, 79, 0.06);

  :before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.25rem 0.1875rem 0 0.1875rem;
    border-color: rgba(48, 69, 79, 1) transparent transparent transparent;
  }
`;

export const TooltipDescription = styled.div`
  opacity: 0.54;
  margin-top: 0.125rem;
`;
